export default __webpack_public_path__ + "static/edit-delivery-30b58503cb4936b4afb3be9df329db9e.png";